import { createAction, props } from '@ngrx/store';
import { EvidenceBase } from '@shared/utils/evidence-management';

export const refreshEvidence = createAction('[ListEvidence] refreshEvidence');
export const listEvidence = createAction('[ListEvidence] listEvidence', props<{ query: string }>());
export const listEvidenceSuccess = createAction('[ListEvidence] listEvidenceSuccess', props<{ evidence: EvidenceBase[]; count: number; query: string }>());
export const sharedWithMeEvidence = createAction('[ListEvidence] sharedWithMeEvidence', props<{ query: string }>());
export const sharedWithMeEvidenceSuccess = createAction('[ListEvidence] sharedWithMeEvidenceSuccess', props<{ evidenceSharedWithMe: EvidenceBase[]; sharedWithMeCount: number }>());
